import React from 'react';

interface ShinyTextProps {
  text: string;
  disabled?: boolean;
  speed?: number;
  className?: string;
}

const ShinyText: React.FC<ShinyTextProps> = ({ 
  text, 
  disabled = false, 
  speed = 5, 
  className = '' 
}) => {
  return (
    <span
      className={`inline-block bg-gradient-to-r from-transparent via-white/80 to-transparent bg-[length:200%_100%] bg-clip-text animate-shine ${
        disabled ? 'animation-none' : ''
      } ${className}`}
      style={{ 
        animationDuration: `${speed}s`,
        WebkitBackgroundClip: 'text',
        color: 'rgba(181, 181, 181, 0.64)'
      }}
    >
      {text}
    </span>
  );
};

export default ShinyText;